<!-- 平台首页 -->
<template>
  <div class='homePage'>
    <div class="left">
        <div class="yljy">
            <div class="yltitle">
                <span class="titleicon"></span>
                <span class="indextitle">面降雨量</span>
                <span class="titleline"></span>
                <div class="datechoose">
                    <span class="yldate-off" v-bind:class='{active:selectedToday}' @click='selectedRainfallTime("today")'>当日</span>
                    <span class="on-line display_off" v-bind:class='{display_active:selectedToday}'></span>
                </div>
                <div class="datechoose">
                    <span class="yldate-off" v-bind:class='{active:selected12Hours}' @click='selectedRainfallTime("12hours")'>12h</span>
                    <span class="on-line display_off" v-bind:class='{display_active:selected12Hours}'></span>
                </div>
                <div class="datechoose">
                    <span class="yldate-off" v-bind:class='{active:selected24Hours}' @click='selectedRainfallTime("24hours")'>24h</span>
                    <span class="on-line display_off" v-bind:class='{display_active:selected24Hours}'></span>
                </div>
            </div>
            <keep-alive>
                <component :is="rainfallContent"></component>
            </keep-alive>
        </div>
        <div class="hdsw">
            <div class="yltitle">
                <span class="titleicon"></span>
                <span class="indextitle">河道水位</span>
                <span class="titleline" style="width: 370px;"></span>
            </div>
            <div id="hedaotable">
                <el-table :data="tableData" stripe :header-cell-style="{background:'#edf1f7'}" class="tableClass" :max-height="height" style="width: 100%; text-align: center;">
                    <el-table-column  prop="stnm"  label="站名" min-width="90">
                    </el-table-column>
                    <el-table-column prop="z"  label="水位(m)" min-width="55">
                        <template slot-scope="scope">
                            <span style="width: 40%;display: block;float: left;text-align: center;">{{ scope.row.z }}</span>
                            <img class="water_level water_level_up" v-if="scope.row.z > scope.row.wrz" :src="image1Url">
                            <img class="water_level water_level_down" v-else-if="scope.row.z < scope.row.wrz" :src="image1Ur2">
                            <img class="water_level_normal" v-else :src="image1Ur3">
                        </template>
                    </el-table-column>
                    <el-table-column prop="wrz"  label="警戒水位(m)" min-width="60">
                    </el-table-column>
                    <el-table-column prop="diff" label="超警戒(m)" min-width="55">
                        <template slot-scope="scope">
                            <span v-if="scope.row.diff > 0" style="color:#ff0000"><b>{{ scope.row.diff }}</b></span>
                            <span v-else>{{ scope.row.diff }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="sksw">
            <div class="yltitle">
                <span class="titleicon"></span>
                <span class="indextitle">水库水位</span>
                <div class="datechoose">
                    <span class="yldate-off" v-bind:class='{active:selectedWaterLevelOne}' @click='selectedWaterLevel("one")'>平水江水库</span>
                    <span class="on-line display_off" v-bind:class='{display_active:selectedWaterLevelOne}'></span>
                </div>
                <div class="datechoose">
                    <span class="yldate-off" v-bind:class='{active:selectedWaterLevelTwo}' @click='selectedWaterLevel("two")'>大雷岙水库</span>
                    <span class="on-line display_off" v-bind:class='{display_active:selectedWaterLevelTwo}'></span>
                </div>
                <div class="datechoose">
                    <span class="yldate-off" v-bind:class='{active:selectedWaterLevelThree}' @click='selectedWaterLevel("three")'>解放水库</span>
                    <span class="on-line display_off" v-bind:class='{display_active:selectedWaterLevelThree}'></span>
                </div>
                <div class="datechoose">
                    <span class="yldate-off" v-bind:class='{active:selectedWaterLevelFour}' @click='selectedWaterLevel("four")'>大岙水库</span>
                    <span class="on-line display_off" v-bind:class='{display_active:selectedWaterLevelFour}'></span>
                </div>
            </div>
            <component :is="waterLevelContent"></component>
        </div>
    </div>
    <div class="center map">
        <leaflet-map></leaflet-map>
    </div>
    <div class="right">
        <div class="jyyb">
            <div class="yltitle">
                <span class="titleicon"></span>
                <span class="indextitle">降雨预报</span>
                <span class="titleline"></span>
                <div class="datechoose">
                    <span class="yldate-off" v-bind:class='{active:selectedForcastOneHour}' @click='selectedForecastTime("oneHour")'>1h</span>
                    <span class="on-line display_off" v-bind:class='{display_active:selectedForcastOneHour}'></span>
                </div><div class="datechoose">
                    <span class="yldate-off" v-bind:class='{active:selectedForcast2Hours}' @click='selectedForecastTime("2Hours")'>2h</span>
                    <span class="on-line display_off" v-bind:class='{display_active:selectedForcast2Hours}'></span>
                </div><div class="datechoose">
                    <span class="yldate-off" v-bind:class='{active:selectedForcast24Hours}' @click='selectedForecastTime("24Hours")'>24h</span>
                    <span class="on-line display_off" v-bind:class='{display_active:selectedForcast24Hours}'></span>
                </div>
            </div>
            <keep-alive>
                <component :is="forcastContent"></component>
            </keep-alive>
        </div>
        <div class="yjlb">
            <div class="yltitle">
                <span class="titleicon"></span>
                <span class="indextitle">预警列表</span>
                <span class="titleline" style="width: 240px;"></span>
                <el-button type="danger" class="allOver" size="mini" plain>批量结束</el-button>
            </div>
            <div id="yjlbtable">
                <el-table :data="tableData1" stripe :header-cell-style="{background:'#edf1f7'}" class="tableClass" :max-height="height" style="width: 100%; text-align: center;">
                    <el-table-column type="selection" width="30">
                    </el-table-column>
                    <el-table-column prop="warningVillage"  label="预警村落" min-width="90">
                    </el-table-column>
                    <el-table-column prop="warningTime"  label="预警时间" min-width="60">
                    </el-table-column>
                    <el-table-column prop="caozuo" label="操作" min-width="35">
                        <el-button size="mini" class="mini_button" type="danger" plain @click="handleDelete(scope.$index, scope.row)">结束</el-button>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="zmkd">
            <el-row class="gate-content">
                <div class="yltitle">
                    <span class="titleicon"></span>
                    <span class="indextitle">闸门开度</span>
                    <span class="titleline" style="width: 300px;"></span>
                    <span class="xiangqing">更多</span>
                    <span class="more"></span>
                </div>
                <div class="zmcontent" :class="{'zmcontent_active':index==choosed}" v-for="(item, index) in gateData" :key="index" @click="checkItem(index)" >
                    <div class="zmtitle" :class="{'zmtitle_active':index==choosed}">
                        <span>{{ item.name}}</span>
                    </div>
                    <div class="zmleft">
                        <div class="zksnum">
                            <span>{{ item.gateNum }}</span>
                        </div>
                        <div class="zks">
                            <span>闸孔数</span>
                        </div>
                    </div>
                    <div class="zmline"></div>
                    <div class="zmlright">
                        <div class="kksnum">
                            <span>{{ item.openGateNum }}</span>
                        </div>
                        <div class="kks">
                            <span>开孔数</span>
                        </div>
                    </div>
                </div>
            </el-row>
        </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import rainFallOneHour from './rainfall/today'
import rainFall12Hour from './rainfall/12Hours'
import rainFall24Hour from './rainfall/24Hours'

import forcastOneHour from './forcast/1HourForcast'
import forcast2Hour from './forcast/2HoursForcast'
import forcast24Hour from './forcast/24HoursForcast'

import waterLevelOne from './waterlevel/waterLevelOne'
import waterLevelTwo from './waterlevel/waterLevelTwo'
import waterLevelThree from './waterlevel/waterLevelThree'
import waterLevelFour from './waterlevel/waterLevelFour'
import centerMap from './map'

import homepageTypes from '@/store/types/homepage'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    rainFallOneHour,
    rainFall12Hour,
    rainFall24Hour,
    forcastOneHour,
    forcast2Hour,
    forcast24Hour,
    waterLevelOne,
    waterLevelTwo,
    waterLevelThree,
    waterLevelFour,
    'leaflet-map': centerMap
  },
  data () {
  // 这里存放数据
    return {
      height: document.documentElement.clientHeight - (document.documentElement.clientHeight * 0.82),
      choosed: 0,
      sID: '22',
      sTID: '',
      stationType: '1',
      tableData: [],
      image1Url: require('@/assets/homepage_img/chaochu.png'),
      image1Ur2: require('@/assets/homepage_img/xiajiang.png'),
      image1Ur3: require('@/assets/homepage_img/zhengchang.png'),
      rainfallContent: rainFallOneHour,
      forcastContent: forcastOneHour,
      waterLevelContent: waterLevelOne,
      selectedToday: true,
      selected12Hours: false,
      selected24Hours: false,
      selectedForcastOneHour: true,
      selectedForcast2Hours: false,
      selectedForcast24Hours: false,
      selectedWaterLevelOne: true,
      selectedWaterLevelTwo: false,
      selectedWaterLevelThree: false,
      selectedWaterLevelFour: false,
      tableData1: [
        {
          warningVillage: '平水村-新横溪村-新庄村',
          warningTime: '2019-5-31 17:15'
        },
        {
          warningVillage: '湖塘街道-永信村-丰里村',
          warningTime: '2019-5-31 17:15'
        },
        {
          warningVillage: '稽东镇-大桥村-上冯村',
          warningTime: '2019-5-31 17:15'
        },
        {
          warningVillage: '稽东镇-俞谢骆村-骆村村',
          warningTime: '2019-5-31 17:15'
        }
      ],
      gateData: [
        {
          name: '萧山枢纽',
          gateNum: '2',
          openGateNum: '2'
        }, {
          name: '新三江闸',
          gateNum: '15',
          openGateNum: '1'
        }, {
          name: '马山闸',
          gateNum: '62',
          openGateNum: '2'
        }, {
          name: '曹娥江大闸',
          gateNum: '28',
          openGateNum: '0'
        }, {
          name: '三兴闸',
          gateNum: '3',
          openGateNum: '2'
        }, {
          name: '浦前闸',
          gateNum: '7',
          openGateNum: '3'
        }, {
          name: '闸头堰闸',
          gateNum: '1',
          openGateNum: '1'
        }, {
          name: '牟山闸',
          gateNum: '2',
          openGateNum: '1'
        }, {
          name: '七塘闸',
          gateNum: '5',
          openGateNum: '3'
        }
      ]
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // 选择面降雨量时间
    selectedRainfallTime (index) {
      if (index === 'today') {
        this.selectedToday = true
        this.selected12Hours = false
        this.selected24Hours = false
        this.rainfallContent = rainFallOneHour
      } else if (index === '12hours') {
        this.selected12Hours = true
        this.selectedToday = false
        this.selected24Hours = false
        this.rainfallContent = rainFall12Hour
      } else if (index === '24hours') {
        this.selected24Hours = true
        this.selectedToday = false
        this.selected12Hours = false
        this.rainfallContent = rainFall24Hour
      } else {}
    },
    // 选择降雨预报时间
    selectedForecastTime (index) {
      if (index === 'oneHour') {
        this.selectedForcastOneHour = true
        this.selectedForcast2Hours = false
        this.selectedForcast24Hours = false
        this.forcastContent = forcastOneHour
      } else if (index === '2Hours') {
        this.selectedForcastOneHour = false
        this.selectedForcast2Hours = true
        this.selectedForcast24Hours = false
        this.forcastContent = forcast2Hour
      } else if (index === '24Hours') {
        this.selectedForcastOneHour = false
        this.selectedForcast2Hours = false
        this.selectedForcast24Hours = true
        this.forcastContent = forcast24Hour
      } else {}
    },
    // 选择水库水位
    selectedWaterLevel (index) {
      if (index === 'one') {
        this.selectedWaterLevelOne = true
        this.selectedWaterLevelTwo = false
        this.selectedWaterLevelThree = false
        this.selectedWaterLevelFour = false
        this.waterLevelContent = waterLevelOne
      } else if (index === 'two') {
        this.selectedWaterLevelOne = false
        this.selectedWaterLevelTwo = true
        this.selectedWaterLevelThree = false
        this.selectedWaterLevelFour = false
        this.waterLevelContent = waterLevelTwo
      } else if (index === 'three') {
        this.selectedWaterLevelOne = false
        this.selectedWaterLevelTwo = false
        this.selectedWaterLevelThree = true
        this.selectedWaterLevelFour = false
        this.waterLevelContent = waterLevelThree
      } else if (index === 'four') {
        this.selectedWaterLevelOne = false
        this.selectedWaterLevelTwo = false
        this.selectedWaterLevelThree = false
        this.selectedWaterLevelFour = true
        this.waterLevelContent = waterLevelFour
      } else {}
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleDelete (index, row) {
      console.log(index, row)
    },
    // 获取河道水位数据
    riverWaterLevelData () {
      this.$store.dispatch(homepageTypes.GET_LATEST_WATER_LEVEL, {
        sID: this.sID,
        sTID: this.sTID,
        stationType: this.stationType
      }).then(data => {
        this.tableData = data.rows
        console.log(data.rows)
      })
    },
    // 选择对应地点闸门开度
    checkItem (index) {
      this.choosed = index
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.riverWaterLevelData()
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
/* @import 'css/index.css'; */
    /*主页*/
    .left{
        width: 545px;
        margin-top: 20px;
        margin-left: 25px;
        background-color: #ffffff;
        float: left;
    }
    .yljy{
        width: 100%;
        height: 330px;
    }
    .top {
        float: left;
    }
    .yltitle{
        width: 100%;
        height: 45px;
        float: left;
        padding: 10px 0;
    }
    .titleicon{
        width: 50px;
        height: 10px;
        background-image: url(../../assets/homepage_img/indextitle.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        display: block;
        float: left;
        margin-top: 6px;
        margin-left: 15px;
    }
    .indextitle{
        font-family: Microsoft YaHei UI;
        font-size: 18px;
        color: #515766;
        display: block;
        float: left;
        margin-left: 10px;
    }
    .titleline{
        border-bottom: 1px solid #d6dbea;
        display: block;
        width: 200px;
        float: left;
        margin-top: 12px;
        margin-left: 15px;
    }
    .datechoose{
        float: left;
        cursor: pointer;
        margin-left: 15px;
        margin-top: 5px;
    }
    .yldate-on{
        width: 100%;
        display: block;
        float: left;
        font-family: Microsoft YaHei UI;
        font-size: 14px;
        font-weight: 600;
        color: #3d6bfb;
    }
    .yldate-off{
        width: 100%;
        display: block;
        float: left;
        font-family: Microsoft YaHei UI;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
    }
    .active{
        width: 100%;
        display: block;
        float: left;
        font-family: Microsoft YaHei UI;
        font-size: 14px;
        font-weight: 600;
        color: #3d6bfb;
    }
    .on-line{
        float: left;
        display: block;
        border-bottom: 3px solid #3d6bfb;
        width: 100%;
    }
    .display_off{
        display: none;
    }
    .display_active{
        display: block;
    }
    .leftpic{
        width: 260px;
        height: 280px;
        background-image: url(../../assets/homepage_img/leftpic.png);
        background-size: 260px 280px;
        background-repeat: no-repeat;
        float: left;
    }
    .hdsw{
        width: 100%;
        height: 240px;
    }
    #hedaotable{
        width: 515px;
        float: left;
        margin-left: 15px;
    }
    .sksw{
        width: 100%;
        height: 278px;
    }
    .leftpic2{
        width: 505px;
        height: 220px;
        overflow: hidden;
        float: left;
        margin-left: 15px;
        position: relative;
    }
    .map{
        width: 740px;
        height: 845px;
        margin-top: 20px;
        margin-left: 20px;
        float: left;
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
    .right{
        width: 545px;
        margin-top: 20px;
        margin-left: 25px;
        background-color: #ffffff;
        float: left;
    }
    .jyyb{
        width: 100%;
        height: 290px;
    }
    .yjlb{
        width: 100%;
        height: 260px;
    }
    #yjlbtable{
        width: 515px;
        float: left;
        margin-left: 15px;
        margin-top: 10px;
    }
    .zmkd{
        width: 100%;
        height: 295px;
    }
    .more{
        display: block;
        float: left;
        background-image: url(../../assets/homepage_img/more.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 11px;
        height: 11px;
        margin-top: 6px;
        margin-left: 15px;
        cursor: pointer;
    }
    .xiangqing{
        display: block;
        float: left;
        font-family: Microsoft YaHei UI;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        margin-top: 3px;
        margin-left: 10px;
    }
    .zmcontent{
        width: 150px;
        height: 75px;
        float: left;
        border: 1px solid #f0f3f8;
        margin-left: 22px;
        margin-top: 5px;
    }
    .zmcontent_active{
        width: 150px;
        height: 75px;
        float: left;
        border: 1px solid #3e76fb;
        margin-left: 22px;
        margin-top: 5px;
    }
    .zmtitle{
        font-family: Microsoft YaHei UI;
        font-size: 14px;
        color: #333333;
        text-align: center;
        width: 100%;
        height: 29px;
        background-color: #f0f3f8;
        padding-top: 6px;
    }
    .zmtitle_active{
        font-family: Microsoft YaHei UI;
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        width: 100%;
        height: 29px;
        background-color: #3e76fb;
        padding-top: 6px;
    }
    .zmleft{
        width: 74px;
        height: 60px;
        float: left;
    }
    .zksnum,.kksnum{
        margin-top: 2px;
        font-family: Microsoft YaHei UI;
        font-size: 14px;
        color: #333333;
        text-align: center;
        width: 100%;
    }
    .zks{
        margin-top: 2px;
        font-family: Microsoft YaHei UI;
        font-size: 12px;
        color: #666666;
        text-align: center;
        width: 100%;
    }
    .zmline{
        border-left: 2px solid #f0f3f8;
        float: left;
        height: 35px;
        margin-top: 5px;
    }
    .kks{
        margin-top: 2px;
        font-family: Microsoft YaHei UI;
        font-size: 12px;
        color: #3d6efb;
        text-align: center;
        width: 100%;
    }
    .water_level{
        width: 10px;
        display: block;
        float: left;
        margin-top: 2px;
    }
    .water_level_normal{
        width: 10px;
        display: block;
        float: left;
        margin-left: 10px;
        margin-top: 10px;
    }
    .allOver{
      width: 80px;
      height: 25px;
      float: right;
      margin-right: 18px;
      padding: 2px
    }
    .mini_button{
      width: 55px;
      height: 25px;
      padding: 2px
    }
</style>
